(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vs-90s-lookbook"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vs-90s-lookbook')) {
    customElements.define('vs-90s-lookbook', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.vs90s-lookbook__track');
        const controls = this.querySelector('.vs90s-lookbook__controls');
        const toggle = this.querySelector('[data-look-toggle]');
        if (!track || !controls || !toggle) return;
        track.querySelectorAll('[data-look-clone]').forEach(card => card.remove());
        const cards = Array.from(track.children);
        if (cards.length < 2) return;
        for (const card of cards) {
          const clone = card.cloneNode(true);
          clone.dataset.lookClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('a').forEach(link => link.tabIndex = -1);
          track.append(clone);
        }
        const firstClone = track.querySelector('[data-look-clone]');
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let paused = motion.matches;
        let touching = false;
        let visible = false;
        let manualUntil = 0;
        let position = track.scrollLeft;
        let loopWidth = 0;
        let lastTime = 0;
        const updateToggle = () => {
          toggle.dataset.paused = String(paused);
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        };
        const resize = () => {
          loopWidth = firstClone.getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
          controls.hidden = loopWidth <= track.clientWidth;
          position = track.scrollLeft;
        };
        toggle.addEventListener('click', () => { paused = !paused; updateToggle(); }, { signal });
        motion.addEventListener('change', () => { paused = motion.matches; updateToggle(); }, { signal });
        track.addEventListener('touchstart', () => { touching = true; }, { passive: true, signal });
        const touchEnd = () => { touching = false; manualUntil = performance.now() + 2500; };
        track.addEventListener('touchend', touchEnd, { passive: true, signal });
        track.addEventListener('touchcancel', touchEnd, { passive: true, signal });
        track.addEventListener('wheel', event => { if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) manualUntil = performance.now() + 1500; }, { passive: true, signal });
        for (const button of controls.querySelectorAll('[data-look-direction]')) {
          button.addEventListener('click', () => {
            if (!loopWidth) return;
            const direction = Number(button.dataset.lookDirection);
            const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
            let current = track.scrollLeft;
            if (direction < 0 && current < step) { current += loopWidth; track.scrollLeft = current; }
            if (direction > 0 && current >= loopWidth) { current -= loopWidth; track.scrollLeft = current; }
            manualUntil = performance.now() + 3000;
            track.scrollTo({ left: current + direction * step, behavior: motion.matches ? 'instant' : 'smooth' });
          }, { signal });
        }
        this.resizeObserver = new ResizeObserver(resize);
        this.resizeObserver.observe(track);
        this.visibilityObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: 0 });
        this.visibilityObserver.observe(track);
        const tick = time => {
          const elapsed = lastTime ? Math.min(time - lastTime, 64) : 0;
          lastTime = time;
          if (paused || touching || !visible || document.hidden || track.querySelector(':focus-visible') || track.matches(':focus-visible') || time < manualUntil || !loopWidth) {
            position = track.scrollLeft;
          } else {
            position = (position + elapsed * .044) % loopWidth;
            track.scrollLeft = position;
          }
          this.animation = requestAnimationFrame(tick);
        };
        resize();
        updateToggle();
        this.animation = requestAnimationFrame(tick);
      }
      stop() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        if (this.animation) cancelAnimationFrame(this.animation);
      }
      disconnectedCallback() { this.stop(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-autumn-leaves"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('vs-autumn-config');
  if (!config || document.getElementById('vs-autumn-layer')) return;
  const end = config.dataset.endDate;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(end || '') || !Number.isFinite(Date.parse(end)) || new Date(end).toISOString().slice(0,10) !== end) return;
  const formatter = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit'});
  const expired = () => {
    const p = Object.fromEntries(formatter.formatToParts(new Date()).map(x => [x.type,x.value]));
    return `${p.year}-${p.month}-${p.day}` > end;
  };
  if (expired()) return;
  const templates = [...config.content.querySelectorAll('img[data-src]')];
  if (!templates.length) return;
  const layer = document.createElement('div');
  layer.id = 'vs-autumn-layer';
  layer.setAttribute('aria-hidden','true');
  layer.setAttribute('inert','');
  document.body.append(layer);
  const overlaps = (a,b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  let timer;
  const place = () => {
    layer.replaceChildren();
    if (expired()) { layer.remove(); return; }
    const main = document.querySelector('main');
    const width = document.documentElement.clientWidth;
    const small = width < 750;
    if (!main || (small && config.dataset.mobile !== 'true')) return;
    const home = config.dataset.page === 'index';
    main.classList.toggle('vs-autumn-decorated', !home);
    const size = small ? 42 : 68;
    const pad = size * 0.65 + 5;
    const bounds = main.getBoundingClientRect();
    let top = Math.max(90, bounds.top + window.scrollY + 12);
    if(home) for(const strip of main.querySelectorAll('.section-vs-marquee,.vs-trust-strip')) top=Math.max(top,strip.getBoundingClientRect().bottom+window.scrollY+24);
    const bottom = bounds.bottom + window.scrollY - pad;
    const rects = [];
    const selector = 'main a, main button, main input, main select, main textarea, main summary, main p, main img, main product-card, main .product-card, main .vsca__card, header, main .section-vs-marquee, main .vs-trust-strip, main .vs-home-faq-strip';
    for (const el of document.querySelectorAll(selector)) {
      const style = getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') continue;
      const r = el.getBoundingClientRect();
      if (r.width && r.height) rects.push({left:r.left,right:r.right,top:r.top+window.scrollY,bottom:r.bottom+window.scrollY});
    }
    for (const el of main.querySelectorAll('h1,h2,h3')) {
      const range = document.createRange();
      range.selectNodeContents(el);
      for (const r of range.getClientRects()) rects.push({left:r.left,right:r.right,top:r.top+window.scrollY,bottom:r.bottom+window.scrollY});
    }
    const positions = [];
    const xs = small ? [width-pad-8,pad+8,width*0.75] : [width-pad-12,pad+12,width*0.78,width*0.58,width*0.38];
    const candidates = [];
    if (!home) {
      const cards = [...main.querySelectorAll('.vsca__card')];
      const rows = [...new Set(cards.map(c=>Math.round(c.getBoundingClientRect().top+window.scrollY)))].sort((a,b)=>a-b);
      for(let i=1;i<rows.length;i++) {
        const previous = cards.filter(c=>Math.abs(c.getBoundingClientRect().top+window.scrollY-rows[i-1])<2);
        const rowBottom = Math.max(...previous.map(c=>c.getBoundingClientRect().bottom+window.scrollY));
        const y=(rowBottom+rows[i])/2;
        const pair=small ? [i%2 ? width*0.8 : width*0.2] : i%2 ? [width*0.18,width*0.78] : [width*0.35,width*0.9];
        for(const x of pair) candidates.push({x,y});
      }
    }
    for(let y=top+pad;y<bottom;y+=28) for(const x of xs) candidates.push({x,y});
    const limit=home ? (small?3:6) : (small?14:28);
    for(const {x,y} of candidates) {
      const area={left:x-pad,right:x+pad,top:y-pad,bottom:y+pad};
      if(rects.some(r=>overlaps(area,r))) continue;
      if(home && positions.some(p=>Math.abs(p.y-y)<350)) continue;
      if(!home && positions.some(p=>Math.abs(p.y-y)<250 && Math.abs(p.x-x)<width*0.45)) continue;
      positions.push({x,y});
      if(positions.length>=limit) break;
    }
    positions.forEach((p,i) => {
      const img=templates[(i*2 + (config.dataset.page==='search'?1:0))%templates.length].cloneNode(false);
      img.src=img.dataset.src;
      img.style.cssText=`left:${p.x-size/2}px;top:${p.y-size/2}px;width:${size}px;height:${size}px;`;
      layer.append(img);
    });
  };
  const schedule = () => { clearTimeout(timer); timer=setTimeout(place,150); };
  if (document.readyState === 'complete') place();
  else window.addEventListener('load',place,{once:true});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  const main=document.querySelector('main');
  const observer=new ResizeObserver(schedule);
  if(main) observer.observe(main);
  const expiry=setInterval(()=>{if(expired()){layer.remove();main?.classList.remove('vs-autumn-decorated');observer.disconnect();clearInterval(expiry);window.removeEventListener('resize',schedule);document.removeEventListener('shopify:section:load',schedule);}},1000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-condition-explainer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vs-defect-viewer')) {
    customElements.define('vs-defect-viewer', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        const dialog = this.querySelector('dialog');
        const track = this.querySelector('.vs-product-defect__photos');
        if (!dialog || !track) return;
        this._abort = new AbortController();
        const signal = this._abort.signal;
        const photos = Array.from(track.querySelectorAll('img:not(.vs-defect-sticker)'));
        photos.forEach((photo) => {
          photo.classList.add('vs-defect-photo');
          if (photo.parentElement.classList.contains('vs-defect-slide')) return;
          const slide = document.createElement('figure');
          slide.className = 'vs-defect-slide';
          const layer = document.createElement('div');
          layer.className = 'vs-defect-annotations';
          layer.setAttribute('aria-hidden', 'true');
          const sticker = document.createElement('img');
          sticker.className = 'vs-defect-sticker';
          sticker.src = 'https://cdn.shopify.com/s/files/1/1025/9965/5754/files/witek-zobacz-wade-v1.png?v=1793444426&width=160';
          sticker.alt = '';
          sticker.width = 80;
          sticker.height = 80;
          sticker.loading = 'lazy';
          layer.append(sticker);
          photo.before(slide);
          slide.append(photo, layer);
        });
        const slides = Array.from(track.querySelectorAll('.vs-defect-slide'));
        const layout = () => {
          photos.forEach((photo, position) => {
            const slide = slides[position];
            const layer = slide.querySelector('.vs-defect-annotations');
            const ratio = (photo.naturalWidth || Number(photo.getAttribute('width'))) / (photo.naturalHeight || Number(photo.getAttribute('height')));
            if (!ratio || !slide.clientHeight) return;
            const width = Math.min(slide.clientWidth, slide.clientHeight * ratio);
            layer.style.width = width + 'px';
            layer.style.height = (width / ratio) + 'px';
          });
        };
        photos.forEach((photo) => photo.addEventListener('load', layout, { signal }));
        const previous = this.querySelector('[data-defect-prev]');
        const next = this.querySelector('[data-defect-next]');
        const counter = this.querySelector('[data-defect-counter]');
        const hint = this.querySelector('[data-defect-hint]');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        let index = 0;
        const update = () => {
          index = track.clientWidth ? Math.max(0, Math.min(photos.length - 1, Math.round(track.scrollLeft / track.clientWidth))) : 0;
          counter.textContent = (index + 1) + ' / ' + photos.length;
          previous.disabled = index === 0;
          next.disabled = index === photos.length - 1;
          slides.forEach((slide, position) => slide.setAttribute('aria-hidden', String(position !== index)));
        };
        const move = (direction) => {
          const position = Math.max(0, Math.min(photos.length - 1, index + direction));
          track.scrollTo({ left: position * track.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        };
        this.querySelector('[data-defect-open]').addEventListener('click', () => {
          if (dialog.open) return;
          dialog.showModal();
          track.scrollLeft = 0;
          layout();
          update();
        }, { signal });
        this.querySelector('[data-defect-close]').addEventListener('click', () => dialog.close(), { signal });
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        }, { signal });
        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, { signal });
        hint.hidden = photos.length < 2;
        this._resize = new ResizeObserver(() => { layout(); update(); });
        this._resize.observe(track);
        update();
      }
      disconnectedCallback() {
        this._abort?.abort();
        this._abort = null;
        this._resize?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-max-unified"] && !Shopify.designMode) return;
  try {
    if (!window.vsMaxUnifiedPreviewBound) {
    window.vsMaxUnifiedPreviewBound = true;
    document.addEventListener('click', function(event) {
      const button = event.target.closest('[data-vs-max-preview-toggle]');
      if (!button || button.disabled) return;
      const card = button.closest('[data-vs-max-unified]');
      if (!card) return;
      const selected = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(selected));
      button.querySelector('[data-max-preview-off]').hidden = selected;
      button.querySelector('[data-max-preview-on]').hidden = !selected;
      card.querySelector('[data-max-preview-selection-note]').hidden = !selected;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-y2k-lookbook"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vs-y2k-lookbook')) {
    customElements.define('vs-y2k-lookbook', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.vsy2k-lookbook__track');
        const controls = this.querySelector('.vsy2k-lookbook__controls');
        const toggle = this.querySelector('[data-look-toggle]');
        if (!track || !controls || !toggle) return;
        track.querySelectorAll('[data-look-clone]').forEach(card => card.remove());
        const cards = Array.from(track.children);
        if (cards.length < 2) return;
        for (const card of cards) {
          const clone = card.cloneNode(true);
          clone.dataset.lookClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('a').forEach(link => link.tabIndex = -1);
          track.append(clone);
        }
        const firstClone = track.querySelector('[data-look-clone]');
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let paused = motion.matches;
        let touching = false;
        let visible = false;
        let manualUntil = 0;
        let position = track.scrollLeft;
        let loopWidth = 0;
        let lastTime = 0;
        const updateToggle = () => {
          toggle.dataset.paused = String(paused);
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        };
        const resize = () => {
          loopWidth = firstClone.getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
          controls.hidden = loopWidth <= track.clientWidth;
          position = track.scrollLeft;
        };
        toggle.addEventListener('click', () => { paused = !paused; updateToggle(); }, { signal });
        motion.addEventListener('change', () => { paused = motion.matches; updateToggle(); }, { signal });
        track.addEventListener('touchstart', () => { touching = true; }, { passive: true, signal });
        const touchEnd = () => { touching = false; manualUntil = performance.now() + 2500; };
        track.addEventListener('touchend', touchEnd, { passive: true, signal });
        track.addEventListener('touchcancel', touchEnd, { passive: true, signal });
        track.addEventListener('wheel', event => { if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) manualUntil = performance.now() + 1500; }, { passive: true, signal });
        for (const button of controls.querySelectorAll('[data-look-direction]')) {
          button.addEventListener('click', () => {
            if (!loopWidth) return;
            const direction = Number(button.dataset.lookDirection);
            const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
            let current = track.scrollLeft;
            if (direction < 0 && current < step) { current += loopWidth; track.scrollLeft = current; }
            if (direction > 0 && current >= loopWidth) { current -= loopWidth; track.scrollLeft = current; }
            manualUntil = performance.now() + 3000;
            track.scrollTo({ left: current + direction * step, behavior: motion.matches ? 'instant' : 'smooth' });
          }, { signal });
        }
        this.resizeObserver = new ResizeObserver(resize);
        this.resizeObserver.observe(track);
        this.visibilityObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: 0 });
        this.visibilityObserver.observe(track);
        const tick = time => {
          const elapsed = lastTime ? Math.min(time - lastTime, 64) : 0;
          lastTime = time;
          if (paused || touching || !visible || document.hidden || track.querySelector(':focus-visible') || track.matches(':focus-visible') || time < manualUntil || !loopWidth) {
            position = track.scrollLeft;
          } else {
            position = (position + elapsed * .044) % loopWidth;
            track.scrollLeft = position;
          }
          this.animation = requestAnimationFrame(tick);
        };
        resize();
        updateToggle();
        this.animation = requestAnimationFrame(tick);
      }
      stop() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        if (this.animation) cancelAnimationFrame(this.animation);
      }
      disconnectedCallback() { this.stop(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
